import React from 'react'
import { Container } from "./SliderElements"
import { Carousel } from "react-bootstrap"
import slider1 from "../../img/slider1.jpg"
import slider2 from "../../img/slider2.jpg"
import slider3 from "../../img/slider4.jpg"
import slider4 from "../../img/slider3.jpg"


export const Slider = () => {
    return (
        <Container>

            <Carousel className="slider">

                <Carousel.Item interval={2000} style={{ maxWidth: "100vw", maxHeight: "100vh" }} className="itemSlider">
                    <div className="item">
                        <img
                            className="d-block w-100"
                            src={slider1}
                            alt="First slide"
                            style={{ maxWidth: "100vw", minHeight: "100vh", objectFit: "cover" }}
                        />
                    </div>
                    <Carousel.Caption style={{ top: "50%", transform: "translateY(-50%)", bottom: "initial" }}>
                        <div className="info-txt-slider">
                            <h3>Ambiente totalmente climatizado</h3>
                        </div>
                    </Carousel.Caption>
                </Carousel.Item>



                <Carousel.Item interval={2000} style={{ maxWidth: "100vw", maxHeight: "100vh" }} className="itemSlider">
                    <div className="item">
                        <img
                            className="d-block w-100"
                            src={slider2}
                            alt="First slide"
                            style={{ maxWidth: "100vw", minHeight: "100vh", objectFit: "cover" }}
                        />
                    </div>
                    <Carousel.Caption style={{ top: "50%", transform: "translateY(-50%)", bottom: "initial" }}>
                        <div className="info-txt-slider">
                            <h3>Contamos com um vasto ambiente com aparelhos mordernos</h3>
                        </div>
                    </Carousel.Caption>
                </Carousel.Item>




                <Carousel.Item interval={2000} style={{ maxWidth: "100vw", maxHeight: "100vh" }} className="itemSlider">
                    <div className="item">
                        <img
                            className="d-block w-100"
                            src={slider3}
                            alt="First slide"
                            style={{ maxWidth: "100vw", minHeight: "100vh", objectFit: "cover" }}
                        />
                    </div>
                    <Carousel.Caption style={{ top: "50%", transform: "translateY(-50%)", bottom: "initial" }}>
                        <div className="info-txt-slider">
                            <h3>Traga os seus amigos e aproveite a promoção de descontos</h3>
                        </div>
                    </Carousel.Caption>
                </Carousel.Item>


                <Carousel.Item interval={2000} style={{ maxWidth: "100vw", maxHeight: "100vh" }} className="itemSlider">
                    <div className="item">
                        <img
                            className="d-block w-100"
                            src={slider4}
                            alt="First slide"
                            style={{ maxWidth: "100vw", minHeight: "100vh", objectFit: "cover" }}
                        />
                    </div>
                    <Carousel.Caption style={{ top: "50%", transform: "translateY(-50%)", bottom: "initial" }}>
                        <div className="info-txt-slider">
                            <h3>A melhor academia localizada no centro da cidade</h3>
                        </div>
                    </Carousel.Caption>
                </Carousel.Item>

            </Carousel>
        </Container>
    )
}
